"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupGameListeners = void 0;
const models_1 = require("@creature-chess/models");
const redux_1 = require("~/plugins/redux");
const registry_1 = require("~/plugins/registry");
const BattleEvents = __importStar(require("~/store/battle/events"));
const sync_1 = require("~/store/board/sync");
const sync_2 = require("~/store/game/players/sync");
const quickChat_1 = require("~/store/game/quickChat");
const actions_1 = require("~/store/game/ui/actions");
const sync_3 = require("~/store/settings/sync");
const battle_1 = require("./battle");
const closeShopOnFirstBuy_1 = require("./closeShopOnFirstBuy");
const endSessionOnGameFinish_1 = require("./endSessionOnGameFinish");
const forwardPlayerActions_1 = require("./forwardPlayerActions");
const preventAccidentalClose_1 = require("./preventAccidentalClose");
const ui_1 = require("./ui");
const setupGameListeners = (startListening) => {
    // Bridge: forward battle finish to network
    startListening({
        actionCreator: BattleEvents.battleFinishEvent,
        effect: (_action, api) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            (_a = api.extra.gameConnectionHolder.peek()) === null || _a === void 0 ? void 0 : _a.sendFinishMatch();
        }),
    });
    // Clear selection when the selected piece is sold
    startListening({
        actionCreator: models_1.PlayerActions.sellPiecePlayerAction,
        effect: (_a, api_1) => __awaiter(void 0, [_a, api_1], void 0, function* ({ payload: { pieceId } }, api) {
            const selectedPieceId = api.getState().game.ui
                .selectedPieceId;
            if (selectedPieceId === pieceId) {
                api.dispatch((0, actions_1.clearSelectedPiece)());
            }
        }),
    });
    // Session must be set before any other listener tries to read it.
    (0, sync_3.setupSettingsListener)(startListening);
    (0, forwardPlayerActions_1.setupForwardPlayerActions)(startListening);
    (0, battle_1.setupClientBattleListeners)(startListening);
    (0, ui_1.setupUiListener)(startListening);
    (0, sync_1.setupBoardSyncListeners)(startListening);
    (0, sync_2.setupPlayersSyncListeners)(startListening);
    (0, quickChat_1.setupQuickChatListener)(startListening);
    (0, closeShopOnFirstBuy_1.setupCloseShopOnFirstBuyListener)(startListening);
    (0, endSessionOnGameFinish_1.setupEndSessionOnGameFinishListener)(startListening);
    (0, preventAccidentalClose_1.setupPreventAccidentalCloseListener)(startListening);
    (0, redux_1.setupPluginListeners)(registry_1.pluginRegistry, startListening);
};
exports.setupGameListeners = setupGameListeners;
